import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

/**
 * Fetch Ranking Nasional with Pagination
 * @param {number} id_tipe_konten
 * @param {number} id_jenis_seleksi
 * @param {number} [page=1] Halaman yang ingin diambil (opsional, default 1)
 * @param {number} [per_page=10] Jumlah item per halaman (opsional, default 10)
 * @returns {Promise<any>}
 */
export const fetchRankingNasional = async (id_tipe_konten, id_jenis_seleksi, page = 1, per_page = 10) => {
  try {
    const params = new URLSearchParams();
    params.append('id_tipe_konten', id_tipe_konten);
    params.append('id_jenis_seleksi', id_jenis_seleksi);
    params.append('page', page);
    params.append('per_page', per_page);

    const response = await axios.get(`${BASE_URL_BE}/tryout-results/ranking-nasional?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching ranking nasional:", error);
    throw error;
  }
};

/**
 * Fetch Ranking Me (posisi user sendiri)
 * @param {number} id_tipe_konten
 * @param {number} id_jenis_seleksi
 * @returns {Promise<any>}
 */
export const fetchRankingMe = async (id_tipe_konten, id_jenis_seleksi) => {
  try {
    const params = new URLSearchParams();
    params.append('id_tipe_konten', id_tipe_konten);
    params.append('id_jenis_seleksi', id_jenis_seleksi);

    const response = await axios.get(`${BASE_URL_BE}/tryout-results/ranking-me?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching ranking me:", error);
    throw error;
  }
};